import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import BlogList from "./BlogList";
import NewBlog from "./NewBlog";
import EditBlog from "./EditBlog";
import RemoveBlog from "./RemoveBlog";
import { useNavigate, useSearchParams } from "react-router-dom";

const Blog = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab');

    const changeTab = (value) => {
        const newParams = new URLSearchParams();
        newParams.set('tab', value);
        navigate({ search: `?${newParams.toString()}` }, { replace: true });
    }
    return (
        <>
            <div className="w-full flex flex-col">
                <Tabs
                    aria-label="Options"
                    className="border-b pb-3"
                    selectedKey={tab || 'list'}
                    onSelectionChange={changeTab}
                    >
                        <Tab key="list" title="لیست">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <BlogList />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="new" title="جدید">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <NewBlog />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="edit" title="ویرایش">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <EditBlog />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="delete" title="حذف">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <RemoveBlog />
                            </CardBody>
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        </>
    );
};

export default Blog;